import React from "react";
import { makeStyles } from "tss-react/mui";

import { Typography } from "@mui/material";

import { ChangedField, formatFieldValue } from "./changedFields";

const useStyles = makeStyles()((theme) => ({
    list: {
        display: "flex",
        flexDirection: "column",
        rowGap: theme.spacing(3),
    },
    field: {
        display: "flex",
        flexDirection: "column",
        rowGap: theme.spacing(0.5),
    },
    change: {
        display: "grid",
        gridTemplateColumns: "min-content minmax(0, 1fr)",
        columnGap: theme.spacing(2),
        rowGap: theme.spacing(1),
        paddingLeft: theme.spacing(4),
    },
    value: {
        fontFamily: "monospace",
        whiteSpace: "pre-wrap",
        overflowWrap: "anywhere",
    },
    path: {
        color: theme.palette.text.secondary,
    },
    changedValue: {
        color: theme.palette.emteria.text.primary,
    },
    mark: {
        lineHeight: theme.typography.body2.lineHeight,
        alignSelf: "start",
    },
    removedMark: {
        color: theme.palette.emteria.error,
    },
    addedMark: {
        color: theme.palette.emteria.success,
    },
}));

export const ChangedFieldsList = ({ fields }: { fields: ChangedField[] }) => {
    const { classes, cx } = useStyles();

    const changeRows = (field: ChangedField) => [
        ...field.removed.map((value) => ({ icon: "fa-minus", markClass: classes.removedMark, value })),
        ...field.added.map((value) => ({ icon: "fa-plus", markClass: classes.addedMark, value })),
    ];

    return (
        <div className={classes.list}>
            {fields.map((field) => (
                <div key={field.path} className={classes.field}>
                    <Typography variant="body2" component="code" className={cx(classes.value, classes.path)}>
                        {field.path}
                    </Typography>
                    <div className={classes.change}>
                        {changeRows(field).map((row, index) => (
                            <React.Fragment key={index}>
                                <i className={cx("fa-solid", row.icon, classes.mark, row.markClass)} aria-hidden />
                                <Typography variant="body2" component="code" className={cx(classes.value, classes.changedValue)}>
                                    {formatFieldValue(row.value)}
                                </Typography>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
